var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row m-b-3" }, [
    _c(
      "div",
      { staticClass: "col-md-6 col-sm-6 col-xs-12 m-b-1 center font-sans" },
      [_vm._v("\n\t\t" + _vm._s(_vm.mailingList.name) + "\n\t\t")]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-6 col-sm-6 col-xs-12" }, [
      _c("input", {
        attrs: {
          type: "hidden",
          name: "mailing_lists[_ids][" + _vm.mailingList.id + "]",
        },
        domProps: { value: _vm.hiddenValue },
      }),
      _vm._v(" "),
      _c(
        "a",
        {
          class: _vm.buttonClasses,
          attrs: { href: "" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.toggleSubscription()
            },
          },
        },
        [
          _vm._v("\n\t\t\tSubscribe "),
          _vm.mailingList.selected
            ? _c("i", { staticClass: "fa fa-check" })
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.hiddenValue === 35
        ? _c(
            "div",
            { staticClass: "form-group select required float-label-control" },
            [
              _vm.hiddenValue === 35
                ? _c(
                    "select",
                    {
                      attrs: {
                        name:
                          "mailing_lists[" +
                          _vm.mailingList.id +
                          "][_joinData][dach_selection]",
                      },
                      domProps: { value: _vm.dachSelection },
                    },
                    [
                      _c("option", { attrs: { value: "CH" } }, [
                        _vm._v("Schweiz"),
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "DE" } }, [
                        _vm._v("Deutschland"),
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "AT" } }, [
                        _vm._v("Österreich"),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hiddenValue === 35
                ? _c("label", { staticClass: "control-label" }, [
                    _vm._v("Land"),
                  ])
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.mailingList.has_preview
        ? _c(
            "a",
            {
              staticClass: "btn btn-default btn-block",
              attrs: {
                href: "#",
                "data-toggle": "modal",
                "data-target": "#preview-" + _vm.mailingList.id,
              },
            },
            [_vm._v("\n\t\t\tPreview\n\t\t")]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }